import { ChangeDetectionStrategy, Component, Input, OnDestroy, TemplateRef } from '@angular/core';
import { NavBarItem } from '@capturum/ui/api';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'cap-nav-item',
  templateUrl: './nav-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavItemComponent implements OnDestroy {
  @Input()
  public item: NavBarItem;

  @Input()
  public contentTemplate: TemplateRef<any>;

  @Input()
  public iconTemplate: TemplateRef<any>;

  public isActiveItem$: Observable<boolean>;

  private destroy$: Subject<void> = new Subject();

  constructor(private router: Router) {
    this.isActiveItem$ = this.router.events.pipe(
      takeUntil(this.destroy$),
      filter((routerEvent) => routerEvent instanceof NavigationEnd),
      map((event: NavigationEnd) => {
        if (this.item.activeSubRoute) {
          return event.url.includes(this.item.activeSubRoute);
        }

        return false;
      }),
    );
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
